"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _typeof2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sideNav = _interopRequireDefault(require("../../components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav.vue"));
var _list = _interopRequireDefault(require("../../components/news/list.vue"));
var _detail = _interopRequireDefault(require("../../components/news/detail.vue"));
var _relativeTime = require("../../assets/static/js/utils/relativeTime.js");
var _api = require("../../api/api");
var _elementUi = require("element-ui");
var _default = exports.default = {
  name: 'newslist',
  components: {
    sideNav: _sideNav.default,
    footNav: _footNav.default,
    list: _list.default,
    detail: _detail.default
  },
  data: function data() {
    return {
      isCollapse: true,
      isNodata: false,
      isNoMoredata: false,
      searchInput: this.$route.query.searchVal,
      select: '危化头条',
      isSearch: this.$route.query.isSearch + '',
      //区分搜索
      isDetail: this.$route.query.isDetail + '',
      //区分详情
      menuVal: this.$route.query.menuVal,
      //栏目
      hasHeaderShadow: false,
      //header的下滑阴影
      menuActive: this.$route.query.menuActive ? this.$route.query.menuActive : 0,
      rdCmmId: '',
      menuData: '',
      //栏目数据
      listData: {
        content: []
      },
      //列表数据
      advertData: '',
      //广告
      carouselData: '',
      //轮播
      searchMenuActiveName: '',
      //搜索页栏目active的name
      page: {
        pageNo: 1,
        pageSize: 10
      },
      //列表请求参数
      hotspotData: [],
      topHeight: '0px',
      scrollHeight: 0,
      isFirstSC: true,
      relatedData: '' //最新咨询列表
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;
      var that, fromProducts, index;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            that = this; // 获取栏目
            _context.next = 3;
            return that.getNewColunm();
          case 3:
            fromProducts = this.$route.params.fromProducts;
            index = 0;
            if (fromProducts) {
              this.menuData.filter(function (item) {
                if (item.colunmName == fromProducts) {
                  _this.menuActive = index;
                }
                index++;
              });
            }
            // 获取右侧最新资讯
            _context.next = 8;
            return that.gethotspotData();
          case 8:
            _context.next = 10;
            return that.getAdvertData('PC_ARTICLE_LIST', '');
          case 10:
            if (this.$route.query.isSearch == 'true') {
              //获取搜索列表
              that.getSearchData(1);
            } else if (this.$route.query.isDetail != 'true') {
              // 获取默认列表
              that.getTopList(that.menuData[that.menuActive].cmmId, that.page.pageNo, that.page.pageSize);
            }
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  mounted: function mounted() {
    var that = this;
    //对ref为content的dom添加滑动监听
    that.$refs.content.addEventListener('scroll', that.throttle(that.handleScroll));
  },
  methods: {
    // 换一批
    refreshReco: function refreshReco() {
      this.$refs['isDetail'].toMoreRelated(this.$refs['isDetail'].relatedPage.pageno, this.$refs['isDetail'].relatedPage.pagesize, this.$refs['isDetail'].ammid);
    },
    // tab栏目切换
    tabChange: function tabChange(index) {
      this.menuActive = index;
      this.isDetail = false;
      this.page.pageNo = 1;
      this.listData.content = [];
      // 请求数据
      this.getTopList(this.menuData[this.menuActive].cmmId, this.page.pageNo, this.page.pageSize);
    },
    getNewColunm: function () {
      var _getNewColunm = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, _yield$apiGetColunm, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return (0, _api.apiGetColunm)({
                applicationType: 'VESCORT_PLATFORM_SYSTEM',
                systemModel: 'CMM_ARTICLE'
              });
            case 3:
              _yield$apiGetColunm = _context2.sent;
              data = _yield$apiGetColunm.data;
              // 测试环境暂且限制7个板块
              // data.proData.splice(7, 1)
              that.menuData = data.proData;
              // 获取热门推荐的cmmid
              that.rdCmmId = that.menuData.filter(function (item) {
                if (item.colunmName == '推荐') {
                  return item.cmmId;
                }
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getNewColunm() {
        return _getNewColunm.apply(this, arguments);
      }
      return getNewColunm;
    }(),
    // 菜单栏切换效果
    changeActive: function changeActive(activeVal) {
      var that = this;
      that.menuActive = activeVal;
      that.isDetail = false;
      that.page.pageNo = 1;
      that.listData.content = [];
      // 获取各栏目列表
      that.getTopList(that.menuData[that.menuActive].cmmId, that.page.pageNo, that.page.pageSize);
    },
    // 二级菜单点击事件
    tosubColumn: function tosubColumn(cmmId, index) {
      var that = this;
      that.isDetail = false;
      that.page.pageNo = 1;
      that.listData.content = [];
      this.menuActive = index;
      // 获取各栏目列表
      that.getTopList(cmmId, 1, 10);
    },
    // 搜索功能
    tosearch: function () {
      var _tosearch = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, _this$$router$resolve, href;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              _this$$router$resolve = this.$router.resolve({
                path: '/search',
                query: {
                  isSearch: true,
                  searchVal: that.searchInput,
                  cmmid: 1,
                  menuActive: that.menuActive
                }
              }), href = _this$$router$resolve.href;
              if (that.searchInput) {
                window.open(href, '_blank');
              } else {
                this.$message({
                  message: '请输入你想要搜索的内容',
                  type: 'warning',
                  duration: '1000'
                });
              }
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function tosearch() {
        return _tosearch.apply(this, arguments);
      }
      return tosearch;
    }(),
    throttle: function throttle(fn) {
      var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      var that = this;
      var canRun = true;
      return function () {
        var _arguments = arguments;
        if (!canRun) return;
        canRun = false;
        setTimeout(function () {
          fn.apply(that, _arguments);
          canRun = true;
        }, interval);
      };
    },
    //监听滑动调用的函数
    handleScroll: function handleScroll() {
      var that = this;
      var scrollTop = that.$refs.content.scrollTop;
      //判断是否第一次滑动,是则获取整个滑动条的高度
      if (that.isFirstSC) {
        that.isFirstSC = false;
        that.scrollHeight = that.$refs.content.scrollHeight;
      }
      //判断滑动高度是否大于列表高度,大于则左侧栏目不再跟随移动
      if (scrollTop < that.scrollHeight - 720) {
        this.topHeight = that.$refs.content.scrollTop + 'px';
      } else {
        this.topHeight = that.scrollHeight - 720 + 'px';
      }
      if (scrollTop > 0) {
        that.hasHeaderShadow = true;
      } else {
        that.hasHeaderShadow = false;
      }
    },
    // 获取右侧广告的请求
    getAdvertData: function () {
      var _getAdvertData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(showType, userId) {
        var that, _yield$apiGetAdvertis, success, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this;
              _context4.next = 3;
              return (0, _api.apiGetAdvertiseData)({
                showType: showType,
                userId: userId
              });
            case 3:
              _yield$apiGetAdvertis = _context4.sent;
              success = _yield$apiGetAdvertis.success;
              data = _yield$apiGetAdvertis.data;
              if (success) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return");
            case 8:
              that.advertData = data.proData;
              that.carouselData = that.advertData.filter(function (item) {
                if (item.showPosition.indexOf('b') != -1) {
                  return item;
                }
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getAdvertData(_x, _x2) {
        return _getAdvertData.apply(this, arguments);
      }
      return getAdvertData;
    }(),
    // 获取栏目列表（有置顶）
    getTopList: function getTopList(cmmid) {
      var that = this;
      if (this.menuData[this.menuActive].colunmName == '推荐') {
        // 热门推荐栏目
        that.findpopularrecommend();
      } else {
        // 其余栏目
        that.findPcByCmmid(cmmid);
      }
    },
    // 获取右侧最新资讯的请求
    gethotspotData: function () {
      var _gethotspotData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, param, _yield$apiGetpcamm, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              that = this;
              param = {
                pageNo: 1,
                pageSize: 4
              };
              _context5.next = 4;
              return (0, _api.apiGetpcamm)(param);
            case 4:
              _yield$apiGetpcamm = _context5.sent;
              data = _yield$apiGetpcamm.data;
              if (data.proCode == '200') {
                that.hotspotData = data.proData;
                // 循环处理发布时间
                that.hotspotData = that.hotspotData.content.filter(function (item) {
                  var date;
                  if (typeof item.articleReleaseTime === 'string') {
                    date = new Date(item.articleReleaseTime.replace(/-/g, '/').replace(/T|Z/g, ' ').trim());
                  } else if ((0, _typeof2.default)(item.articleReleaseTime) === 'object') {
                    date = new Date(item.articleReleaseTime);
                  }
                  item.articleReleaseTime = parseInt(date.getMonth()) + 1 + '-' + date.getDate();
                  return item;
                });
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function gethotspotData() {
        return _gethotspotData.apply(this, arguments);
      }
      return gethotspotData;
    }(),
    //获取搜索列表
    getSearchData: function () {
      var _getSearchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(pageNo) {
        var loadInstance, that, param, _yield$apiArticlSearc, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              that = this;
              param = {
                keyWord: this.$route.query.searchVal,
                pageNo: pageNo,
                pageSize: 10
              };
              _context6.next = 5;
              return (0, _api.apiArticlSearch)(param);
            case 5:
              _yield$apiArticlSearc = _context6.sent;
              data = _yield$apiArticlSearc.data;
              console.log('data=>', data);
              loadInstance.close();
              if (data.proCode == '200') {
                if (data.proData != null && data.proData.length > 0) {
                  that.timeToRealative(data.proData);
                  that.searchMenuActiveName = data.proData ? data.proData[0].colunmNames : '';
                } else if (that.listData.content.length > 0) {
                  that.isNoMoredata = true;
                } else {
                  that.isNodata = true;
                }
              }
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getSearchData(_x3) {
        return _getSearchData.apply(this, arguments);
      }
      return getSearchData;
    }(),
    // 请求热门推荐栏目列表
    findpopularrecommend: function () {
      var _findpopularrecommend = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var loadInstance, that, param, paramStr, reqParam, _yield$apiGetPopularR, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              that = this;
              param = {
                "pageSize": 10,
                "pageNo": 1
              };
              paramStr = {
                "version": "1",
                "fun": "findpopularrecommend",
                "param": param
              };
              reqParam = {
                jsonParamete: JSON.stringify(paramStr)
              };
              _context7.next = 7;
              return (0, _api.apiGetPopularRecommend)(reqParam);
            case 7:
              _yield$apiGetPopularR = _context7.sent;
              data = _yield$apiGetPopularR.data;
              loadInstance.close();
              if (data.proCode == '200') {
                that.listData.content = data.proData;
                if (data.proData.length != 0) {
                  // 循环处理发布时间
                  that.listData.content = that.listData.content.filter(function (item) {
                    if (item.articleReleaseTime != 'null') {
                      item.articleReleaseTime = (0, _relativeTime.getDate)(item.articleReleaseTime);
                    } else {
                      item.articleReleaseTime = '未知';
                    }
                    if (item.articleCoverStyle == 'ARTICLE_COVER_THREE') {
                      item.pictureOssUrls = item.pictureOssUrls.split(',');
                    }
                    return item;
                  });
                  that.isNodata = false;
                } else {
                  that.isNodata = true;
                }
              }
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function findpopularrecommend() {
        return _findpopularrecommend.apply(this, arguments);
      }
      return findpopularrecommend;
    }(),
    // 请求其余栏目列表
    findPcByCmmid: function () {
      var _findPcByCmmid = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(cmmid) {
        var loadInstance, that, param, _yield$apiGetPcByCmmi, data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              that = this;
              param = {
                cmmId: cmmid,
                pageNo: 1,
                pageSize: 10
              };
              _context8.next = 5;
              return (0, _api.apiGetPcByCmmid)(param);
            case 5:
              _yield$apiGetPcByCmmi = _context8.sent;
              data = _yield$apiGetPcByCmmi.data;
              loadInstance.close();
              if (data.proCode == '200') {
                that.listData = data.proData;
                if (data.proData.content.length != 0) {
                  // 循环处理发布时间
                  that.listData.content = that.listData.content.filter(function (item) {
                    if (item.articleReleaseTime != 'null') {
                      item.articleReleaseTime = (0, _relativeTime.getDate)(item.articleReleaseTime);
                    } else {
                      item.articleReleaseTime = '未知';
                    }
                    if (item.articleCoverStyle == 'ARTICLE_COVER_THREE') {
                      item.pictureOssUrls = item.pictureOssUrls.split(',');
                    }
                    return item;
                  });
                  that.isNodata = false;
                } else {
                  that.isNodata = true;
                }
              }
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function findPcByCmmid(_x4) {
        return _findPcByCmmid.apply(this, arguments);
      }
      return findPcByCmmid;
    }(),
    // 日期格式转换
    timeToRealative: function timeToRealative(proData) {
      var that = this;
      if (proData != null && proData.length > 0) {
        proData = proData.filter(function (item) {
          if (item.articleReleaseTime) {
            item.articleReleaseTime = (0, _relativeTime.getDate)(item.articleReleaseTime);
          } else {
            item.articleReleaseTime = '未知';
          }
          if (item.articleCoverStyle == 'ARTICLE_COVER_THREE') {
            item.pictureOssUrls = item.pictureOssUrls.split(',');
          }
          return item;
        });
        that.listData.content = that.listData.content.concat(proData);
        if (that.isSearch == 'true') {
          that.listData.content.filter(function (item) {
            item.articleTitle = '<span>' + item.articleTitle + '</span>';
            var tem = "<span style='color: red'>" + that.searchInput + "</span>";
            item.articleTitle = item.articleTitle.replace(that.searchInput, tem);
          });
        }
      }
    }
  },
  watch: {
    $route: function $route() {
      var that = this;
      that.isSearch = that.$route.query.isSearch + '';
      that.isDetail = that.$route.query.isDetail + '';
      that.menuActive = that.$route.query.menuActive ? that.$route.query.menuActive : 0;
      that.searchInput = that.$route.query.searchVal;
      that.listData.content = [];
      if (that.$route.query.isSearch == 'true') {
        //获取搜索列表
        that.getSearchData(1);
      } else {
        that.getTopList(that.menuData[that.menuActive].cmmId, 1, that.page.pageSize);
      }
    }
  }
};